import script from "./CustomerTab.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerTab.vue?vue&type=script&setup=true&lang=js"

import "./CustomerTab.vue?vue&type=style&index=0&id=06ca380d&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06ca380d"]])

export default __exports__